import * as go from 'gojs';

export enum ExportMode {
  Diagram,
  Viewport,
}

const savePng = (result: Blob) => {
  const a = document.createElement('a');
  document.body.appendChild(a);
  const url = window.URL.createObjectURL(result);
  a.href = url;
  a.download = 'diagram.png';
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
};

const defaultOptions = {
  background: 'white',
  type: 'image/png',
  returnType: 'blob',
  callback: savePng,
};

const exportFullDiagram = (diagram: go.Diagram) => {
  diagram.makeImageData({
    ...defaultOptions,
    scale: 1,
    size: diagram.documentBounds.size,
    maxSize: diagram.documentBounds.size,
  });
};

const exportCurrentViewport = (diagram: go.Diagram) => {
  diagram.makeImageData({
    ...defaultOptions,
    position: new go.Point(diagram.viewportBounds.x, diagram.viewportBounds.y),
    size: diagram.viewportBounds.size,
    maxSize: diagram.viewportBounds.size,
  });
};

export const exportPng = (diagram: go.Diagram, mode: ExportMode) => {
  switch (mode) {
    case ExportMode.Diagram:
      exportFullDiagram(diagram);
      break;
    case ExportMode.Viewport:
      exportCurrentViewport(diagram);
      break;
    default:
      throw Error('Unknown export option!');
  }
};
